<div>
  <textarea id="message" rows="4" :name="name" @change="onUpdateText" :value="value"
    class="bg-qr_color-gray_3 h-120 px-2.5 py-2 text-qr_color-gray peer rounded-qr_input_radius block w-full border-0 focus:ring-0 focus:border-transparent my-2"
    :placeholder="placeHolder" v-on="inputListeners" :hasValidators="hasValidators"></textarea>
  <span v-if="errorMessage && errorMessage !==''" class="text-qr_color-error">{{errorMessage}}</span>
</div>